export default "__VITE_ASSET__DJhycd6Y__"